// Would You Rather's words in the languages its questions come in (English, Spanish, Portuguese, French, Dutch and
// Arabic; by the student's language or the settings). Dutch is "nl" here and for students, "du" in the content
// (questions_du); Arabic reads right to left.
export const LANGS = ['en', 'sp', 'pt', 'fr', 'nl', 'ab']

export const TEXTS = {
    en: {
        or: 'or',
        pick: 'Tap your choice!',
        picked: 'My pick!',
        frame: ['I would rather', 'because…'],
        say: 'Say why! Then score it with C, A or W on the student’s card.',
        scored: { 1: 'Great reason!', 2: 'Almost! Tell me more.', 0: 'Let’s try again together.' },
        hear: 'Hear it',
        hearChoice: 'Hear “{text}”',
        question: 'Question',
        of: 'of',
        next: 'Next',
        previous: 'Previous question',
        nextLabel: 'Next question',
        bulbs: '{n} good reasons',
        empty: 'No questions in this language.',
        kicker: 'This or that?',
        title: ['Would You', 'Rather?'],
        welcomeSub: 'Listen to the two choices, pick one, and say why!',
        play: 'Let’s choose!',
        settings: 'Would You Rather settings',
        language: 'Language',
        languageSub: 'Changing it deals the questions again',
        helper: 'Sentence helper',
        helperSub: '“I would rather ___ because…” after a pick',
        readChoices: 'Read the choices aloud',
        readChoicesSub: 'After the question, one after the other',
        on: 'On',
        off: 'Off',
        note: 'For this session',
    },
    sp: {
        or: 'o',
        pick: '¡Toca tu opción!',
        picked: '¡Mi opción!',
        frame: ['Prefiero', 'porque…'],
        say: '¡Di por qué! Luego califica con C, A o W en la tarjeta del estudiante.',
        scored: { 1: '¡Muy buena razón!', 2: '¡Casi! Cuéntame más.', 0: 'Intentémoslo juntos.' },
        hear: 'Escuchar',
        hearChoice: 'Escuchar “{text}”',
        question: 'Pregunta',
        of: 'de',
        next: 'Siguiente',
        previous: 'Pregunta anterior',
        nextLabel: 'Pregunta siguiente',
        bulbs: '{n} buenas razones',
        empty: 'No hay preguntas en este idioma.',
        kicker: '¿Esto o aquello?',
        title: ['¿Qué', 'prefieres?'],
        welcomeSub: 'Escucha las dos opciones, elige una y di por qué.',
        play: '¡A elegir!',
        settings: 'Ajustes de ¿Qué prefieres?',
        language: 'Idioma',
        languageSub: 'Al cambiarlo se reparten las preguntas de nuevo',
        helper: 'Ayuda para la frase',
        helperSub: '“Prefiero ___ porque…” después de elegir',
        readChoices: 'Leer las opciones en voz alta',
        readChoicesSub: 'Después de la pregunta, una tras otra',
        on: 'Sí',
        off: 'No',
        note: 'Durante esta sesión',
    },
    pt: {
        or: 'ou',
        pick: 'Toque na sua escolha!',
        picked: 'Minha escolha!',
        frame: ['Eu prefiro', 'porque…'],
        say: 'Diga por quê! Depois pontue com C, A ou W no cartão do aluno.',
        scored: { 1: 'Ótimo motivo!', 2: 'Quase! Conte mais.', 0: 'Vamos tentar de novo juntos.' },
        hear: 'Ouvir',
        hearChoice: 'Ouvir “{text}”',
        question: 'Pergunta',
        of: 'de',
        next: 'Próxima',
        previous: 'Pergunta anterior',
        nextLabel: 'Próxima pergunta',
        bulbs: '{n} bons motivos',
        empty: 'Não há perguntas neste idioma.',
        kicker: 'Isto ou aquilo?',
        title: ['Você', 'prefere?'],
        welcomeSub: 'Ouça as duas opções, escolha uma e diga por quê!',
        play: 'Vamos escolher!',
        settings: 'Configurações de Você prefere?',
        language: 'Idioma',
        languageSub: 'Ao mudar, as perguntas são distribuídas de novo',
        helper: 'Ajuda para a frase',
        helperSub: '“Eu prefiro ___ porque…” depois da escolha',
        readChoices: 'Ler as opções em voz alta',
        readChoicesSub: 'Depois da pergunta, uma após a outra',
        on: 'Sim',
        off: 'Não',
        note: 'Nesta sessão',
    },
    fr: {
        or: 'ou',
        pick: 'Touche ton choix !',
        picked: 'Mon choix !',
        frame: ['Je préfère', 'parce que…'],
        say: 'Dis pourquoi ! Puis notez avec C, A ou W sur la carte de l’élève.',
        scored: { 1: 'Très bonne raison !', 2: 'Presque ! Dis-m’en plus.', 0: 'Essayons encore ensemble.' },
        hear: 'Écouter',
        hearChoice: 'Écouter « {text} »',
        question: 'Question',
        of: 'sur',
        next: 'Suivant',
        previous: 'Question précédente',
        nextLabel: 'Question suivante',
        bulbs: '{n} bonnes raisons',
        empty: 'Pas de questions dans cette langue.',
        kicker: 'Ceci ou cela ?',
        title: ['Tu', 'préfères ?'],
        welcomeSub: 'Écoute les deux choix, choisis-en un et dis pourquoi !',
        play: 'On choisit !',
        settings: 'Réglages de Tu préfères ?',
        language: 'Langue',
        languageSub: 'En la changeant, les questions sont redistribuées',
        helper: 'Aide pour la phrase',
        helperSub: '« Je préfère ___ parce que… » après un choix',
        readChoices: 'Lire les choix à voix haute',
        readChoicesSub: 'Après la question, l’un après l’autre',
        on: 'Oui',
        off: 'Non',
        note: 'Pendant cette séance',
    },
    nl: {
        or: 'of',
        pick: 'Tik op je keuze!',
        picked: 'Mijn keuze!',
        frame: ['Ik zou liever', 'omdat…'],
        say: 'Zeg waarom! Score het daarna met C, A of W op de kaart van de leerling.',
        scored: { 1: 'Goede reden!', 2: 'Bijna! Vertel eens meer.', 0: 'We proberen het samen nog eens.' },
        hear: 'Luister',
        hearChoice: 'Luister naar “{text}”',
        question: 'Vraag',
        of: 'van',
        next: 'Volgende',
        previous: 'Vorige vraag',
        nextLabel: 'Volgende vraag',
        bulbs: '{n} goede redenen',
        empty: 'Geen vragen in deze taal.',
        kicker: 'Dit of dat?',
        title: ['Wat zou je', 'liever?'],
        welcomeSub: 'Luister naar de twee keuzes, kies er één en zeg waarom!',
        play: 'Kiezen maar!',
        settings: 'Instellingen van Wat zou je liever?',
        language: 'Taal',
        languageSub: 'Bij een andere taal worden de vragen opnieuw verdeeld',
        helper: 'Zinshulp',
        helperSub: '“Ik zou liever ___ omdat…” na een keuze',
        readChoices: 'Keuzes voorlezen',
        readChoicesSub: 'Na de vraag, de een na de ander',
        on: 'Aan',
        off: 'Uit',
        note: 'Voor deze sessie',
    },
    ab: {
        or: 'أم',
        pick: 'المس اختيارك!',
        picked: 'اختياري!',
        frame: ['أفضّل', 'لأن…'],
        say: 'قل لماذا! ثم قيّم الإجابة بـ C أو A أو W على بطاقة الطالب.',
        scored: { 1: 'سبب رائع!', 2: 'تقريبًا! أخبرني أكثر.', 0: 'لنحاول مرة أخرى معًا.' },
        hear: 'استمع',
        hearChoice: 'استمع إلى «{text}»',
        question: 'السؤال',
        of: 'من',
        next: 'التالي',
        previous: 'السؤال السابق',
        nextLabel: 'السؤال التالي',
        bulbs: '{n} أسباب جيدة',
        empty: 'لا توجد أسئلة بهذه اللغة.',
        kicker: 'هذا أم ذاك؟',
        title: ['ماذا', 'تفضّل؟'],
        welcomeSub: 'استمع إلى الاختيارين، واختر واحدًا، وقل لماذا!',
        play: 'هيا نختار!',
        settings: 'إعدادات ماذا تفضّل؟',
        language: 'اللغة',
        languageSub: 'عند تغييرها تُوزَّع الأسئلة من جديد',
        helper: 'مساعد الجملة',
        helperSub: '«أفضّل ___ لأن…» بعد الاختيار',
        readChoices: 'قراءة الاختيارات بصوت عالٍ',
        readChoicesSub: 'بعد السؤال، واحدًا تلو الآخر',
        on: 'نعم',
        off: 'لا',
        note: 'لهذه الجلسة',
    },
}

// The student's language when the game has it (Spanish also as "es"/"spanish"), English otherwise.
export const languageOf = (lang) => {
    const code = String(lang || '').toLowerCase()
    if (LANGS.includes(code)) return code
    if (code === 'du') return 'nl'
    return code.startsWith('s') ? 'sp' : 'en'
}

// The content's key for a language's questions (Dutch is questions_du).
export const questionsKey = (lang) => `questions_${lang === 'nl' ? 'du' : lang}`

// Settings, kept with the student's place: the language (from the student's language at first), whether the sentence
// helper shows after a pick, and whether the two choices are read aloud after the question.
export const settingsOf = (saved, studentLang) => {
    const s = saved || {}
    return {
        language: LANGS.includes(s.language) ? s.language : languageOf(studentLang),
        helper: s.helper !== false,
        readChoices: s.readChoices === true,
    }
}
